// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"6d24e964","787":"e4c23ce0"}[chunkId] + ".chunk.js";
};